import CommentsModel from '../model/comments';
import consts from '../consts/const';

import UserInfo from '../model/userinfo';
import PostModel from '../model/posts';

export const GET_COMM = 'GET_COMM';


export const GET_FOLLOW = 'GET_FOLLOW';
export const GET_FOLLOW_USER = 'GET_FOLLOW_USER';
export const GET_VISTED_POSTS = 'GET_VISTED_POSTS';


export const  get_comm = () =>{
  return async dispatch =>{
    const res= await fetch(`http://${consts.url}/api/main/aac.php`);
    const data =[];
    const ress = await res.json();
    for(const key in ress){
    data.push(new CommentsModel(ress[key].id,ress[key].content,+ress[key].postid,ress[key].userid,ress[key].date))
    }

// console.log(data)
    dispatch({type:'GET_COMM',data:ress})
  }
}


export const  get_user_info = (id) =>{
  return async (dispatch,getState) =>{
// console.log(id)
    const res= await fetch(`/api/auth/auth/${id}`);
    const data =[];
     const resses = await res.json();
     // console.log(resses)
     const ress = resses.msg;
    for(const key in ress){
    data.push(new UserInfo(ress[key].id,ress[key].userid,ress[key].email,ress[key].country,ress[key].job,ress[key].hobby,ress[key].img,ress[key].big_img,ress[key].first_name,resses.following,resses.leading,ress[key].bio,ress[key].age,ress[key].story))
    }
      // data.push(new UserInfo(ress.id,ress.userid,ress.email,ress.country,ress.job,ress.hobby,ress.img,ress.big_img,ress.frist_name,resses.leading,resses.following,ress.bio))

// console.log(ress,id,data)
    dispatch({type:'GET_FOLLOW_USER',data:data})
  }
}


export const  get_visted_posts = (userid) =>{
  return async (dispatch,getState) =>{
    // console.log(userid)
    const res= await fetch(`/api/posts/userPosts/${userid}`);
    const vistedPost =[];
    const ress = await res.json();


    for(const key in ress){
    const row = ress[key];
    if (!row?.id) continue;
    vistedPost.push(new PostModel(row.id,row.image || row.content,row.title,row.type,row.userid,row.tages,row.disc || row.discrption || row.description,row.time,row.thumbnail,row.vCount,row.comm,row.pCount,row.dCount,row.userImg,row.email,row.userLink))
    }


// console.log(vistedPost);
    dispatch({type:'GET_VISTED_POSTS',data:vistedPost})
  }
}
